import { useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import LayoutSubmaster from "../../components/layoutSubmasterConfig/layoutSubmaster"
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import { apiClientSubmaster } from "../../services/setupClientSubmaster/apiClientSubmaster";
import { toast } from "react-toastify";
import LocalStorage from "../../helpers/localstorage";
import axios from "axios";
import edit from '../../components/dashboard/img/favicon/editar.png';
import {
    createSimplePdfBlob,
    downloadBlob,
    formatDateForFileName,
    runPdfOnlyBackup,
    sanitizeFileName,
} from "../../helpers/backupExport";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";

function ConfigSubmasterUserPage(){

    const marginFilter = { marginLeft: "-0.3%"};

    let localStorage = new LocalStorage()
    const canManageUsers = localStorage.isWebMasterOrLegacy();

    const [showFormupdateEmployess ,setShowFormupdateEmployess] = useState(false);
    const [showFormCreateUser ,setShowFormCreateEmployess] = useState(false);
    const [showCreatePassword, setShowCreatePassword] = useState(false);


    type DataRow = {
        id: number;
        name: string;
        email: string;
        address: string;
        cpf: string;
        neighborhood: string;
        postal_code: string;
        city: string;
        state: string;
        number: string;
        house_number: string;
        submasterId: number;
        active: boolean;
    };

    const sortUsersAlphabetically = (rows: DataRow[]) =>
        [...rows].sort((firstUser, secondUser) =>
            firstUser.name.localeCompare(secondUser.name, "pt-BR", {
                sensitivity: "base",
                ignorePunctuation: true,
            })
        );
      

    const [getData, setgetData] = useState<DataRow[]>([]);
    const [masterDataDeleteEnabled, setMasterDataDeleteEnabled] = useState(false);
    const [deletingUserId, setDeletingUserId] = useState<number | null>(null);
    const [showEmployeesFormUpdate ,setShowEmployeesFormUpdate ] = useState(false);
    
    const [formData, setFormData] = useState<{
        id: number;
        name: string;
        email: string;
        cpf: string;
        address: string;
        neighborhood: string;
        postal_code: string;
        city: string;
        state: string;
        number: string;
        house_number: string;
        submasterId: number;
        password: string;
        active: boolean;
      }>({
        id: 0,
        name: "",
        email: "",
        cpf: "",
        number: "",
        address: "",
        city: "",
        postal_code: "",
        state: "",
        neighborhood: "",
        house_number: "",
        submasterId: 0,
        password: "",
        active: true

    });
      
    const resetData = () => {
        setFormData({
            id: 0,
            name: "",
            email: "",
            cpf: "",
            number: "",
            address: "",
            city: "",
            postal_code: "",
            state: "",
            neighborhood: "",
            house_number: "",
            submasterId: 0,
            password: "",
            active: true}
        )
    }
      
    const formatCpfCustom = (value: string) => {
        return value
        .replace(/\D/g, '') // Remove tudo que não for número
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4'); // Aplica a máscara
    };
      

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
      
        let formattedValue = value;
      
        if (name === 'cpf') {
          formattedValue = formatCpfCustom(value);
        }
      
        setFormData({
          ...formData,
          [name]: formattedValue,
        });
    };

    const handleDeleteUser = async (row: DataRow) => {
        if (deletingUserId !== null) return;
        if (!window.confirm(`Deseja excluir o usuário ${row.name}? Esta ação não pode ser desfeita.`)) return;

        try {
            setDeletingUserId(row.id);
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post(
                `/crud/delete/UserSubmaster/${row.id}/${localStorage.getId()}`
            );
            if (!response?.data?.res) {
                toast.warning(response?.data?.message || "Não foi possível excluir o usuário.");
                return;
            }
            setgetData((current) => current.filter((item) => item.id !== row.id));
            toast.success("Usuário excluído com sucesso.");
        } catch (error) {
            const message = axios.isAxiosError(error)
                ? error.response?.data?.message
                : null;
            toast.warning(message || "Não foi possível excluir o usuário.");
        } finally {
            setDeletingUserId(null);
        }
    };
      

    // Colunas da tabela com ícones mais coerentes
   const columns: TableColumn<DataRow>[] = [
  {
    name: (
      <span>
        <i className="bi bi-person-check-fill me-1 text-success"></i>
        <span className="text-success fw-bold">Status</span>
      </span>
    ),
    cell: (row) => (
      <span className={`badge ${row.active ? "bg-success" : "bg-secondary"}`}>
        {row.active ? "Ativo" : "Inativo"}
      </span>
    ),
    sortable: true,
    sortFunction: (first, second) => Number(second.active) - Number(first.active),
  },
  {
    name: (
      <span>
        <i className="bi bi-person-fill me-1 text-primary"></i>
        <span className="text-primary fw-bold">Nome</span>
      </span>
    ),
    selector: (row) => row.name,
    sortable: true,
  },
  {
    name: (
      <span>
        <i className="bi bi-credit-card-2-front-fill me-1 text-secondary"></i>
        <span className="text-secondary fw-bold">CPF</span>
      </span>
    ),
    selector: (row) => row.cpf,
    sortable: true,
  },
  {
    name: (
      <span>
        <i className="bi bi-telephone-fill me-1 text-success"></i>
        <span className="text-success fw-bold">Telefone</span>
      </span>
    ),
    selector: (row) => row.number,
    sortable: true,
  },
  {
    name: (
      <span>
        <i className="bi bi-envelope-fill me-1 text-info"></i>
        <span className="text-info fw-bold">E-mail</span>
      </span>
    ),
    selector: (row) => row.email,
    sortable: true,
  },
  ...(canManageUsers ? [{
    name: (
      <span>
        <i className="bi bi-pencil-square me-1 text-primary"></i>
        <span className="text-primary fw-bold">Editar</span>
      </span>
    ),
    cell: (row) => (
      <button
        className="btn btn-outline-primary btn-sm"
        onClick={() => handleButtonUpdate(row.id)}
        title="Editar"
      >
        <i className="bi bi-pencil-fill"></i>
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  } as TableColumn<DataRow>] : []),
  ...(masterDataDeleteEnabled && canManageUsers ? [{
    name: (
      <span>
        <i className="bi bi-trash3 me-1 text-danger"></i>
        <span className="text-danger fw-bold">Excluir</span>
      </span>
    ),
    cell: (row: DataRow) => (
      <button
        className="btn btn-outline-danger btn-sm"
        onClick={() => void handleDeleteUser(row)}
        disabled={deletingUserId === row.id}
        title="Excluir usuário"
      >
        <i className={`bi ${deletingUserId === row.id ? "bi-hourglass-split" : "bi-trash3"}`}></i>
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  } as TableColumn<DataRow>] : [])
];




      
    const handleButtonUpdate = (id: number) => {
        const selectedItem = getData.find((item) => item.id === id);

        setShowEmployeesFormUpdate(true)
        setFormData({
            id: selectedItem?.id ?? 0,
            name: selectedItem?.name || "",
            email: selectedItem?.email || "",
            cpf: selectedItem?.cpf || "",
            address: selectedItem?.address || "",
            neighborhood: selectedItem?.neighborhood || "",
            postal_code: selectedItem?.postal_code || "",
            city: selectedItem?.city || "",
            state: selectedItem?.state || "",
            number: selectedItem?.number || "",
            house_number: selectedItem?.house_number || "",
            submasterId: Number(localStorage.getId()),
            password: "",
            active: selectedItem?.active !== false
        });
          
          

        console.log(`Item com ID ${id} foi clicado! ${formData?.city}`);
    }
    
    function maskPhone(e: React.ChangeEvent<HTMLInputElement>){
        let phone = e.target.value;
        phone = phone.replace(/\D/g, ''); // Remove tudo o que não é número
        phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
        phone = phone.replace(/(\d{5})(\d{1,4})$/, '$1-$2');
        setFormData({ ...formData, number: phone });
    };

    /*async function handleChangePostalcode(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
        const newPostalCode = e.target.value;
    
        setFormData({
        ...formData,
        postal_code: newPostalCode,
        });
    
        const apiclient = Zip_Code_Api(newPostalCode);
        const response = await apiclient.get("");
    
        if (response && response.data) {
            setFormData(prev => ({
                ...prev,
                postal_code: newPostalCode, // garante que continua
                neighborhood: response.data.bairro,
                state: response.data.estado,
                city: response.data.localidade,
                address: response.data.logradouro,
            }));
        }
    }*/
   async function handleChangePostalcode(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) 
    {
        const newPostalCode = e.target.value;

        setFormData({
            ...formData,
            postal_code: newPostalCode,
        });

        if (newPostalCode.length === 8) {
            // Mostra toast fixo
            const toastId = toast.info("Buscando CEP...", {
                position: "top-right",
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                closeButton: false,
            });

            try {
                const apiclient = Zip_Code_Api(newPostalCode);
                const response = await apiclient.get("");

                if (response && response.data) {
                    if (response.data.erro === "true") {
                        throw new Error("CEP não encontrado");
                    }

                    setFormData((prev) => ({
                        ...prev,
                        postal_code: newPostalCode,
                        neighborhood: response.data.bairro,
                        state: response.data.estado,
                        city: response.data.localidade,
                        address: response.data.logradouro,
                    }));

                   toast.success("Endereço encontrado", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                    toast.dismiss(toastId);
                }
            } catch (error) {
                toast.update(toastId, {
                    render: error.message || "Erro ao buscar o CEP.",
                    type: "error",
                    autoClose: 3000,
                });
            }

        }
    }



    const [filterText, setFilterText] = useState(""); 
    const [backupLoading, setBackupLoading] = useState(false);

    const filteredData = getData.filter(
        (item) =>
          item.email?.toLowerCase().includes(filterText.toLowerCase())  || 
        item.name?.toLowerCase().includes(filterText.toLowerCase())
    );
    const totalUsers = getData.length;
    const filteredUsers = filteredData.length;

    const handleBackup = async () => {
        if (backupLoading) {
            return;
        }

        if (filteredData.length === 0) {
            toast.info("Não há usuários para incluir no backup.");
            return;
        }

        setBackupLoading(true);
        const dateSuffix = formatDateForFileName(new Date());
        const toastId = toast.info(`Gerando backup... 0/${filteredData.length}`, {
            position: "top-right",
            autoClose: false,
            closeOnClick: false,
            draggable: false,
            closeButton: false,
        });

        try {
            const summary = await runPdfOnlyBackup<DataRow>({
                items: filteredData,
                zipRootName: `backup_usuarios_${dateSuffix}`,
                getLabel: (item) => item.name,
                onProgress: (done, total) => {
                    toast.update(toastId, { render: `Gerando backup... ${done}/${total}` });
                },
                processItem: async (item) => {
                    const pdfFileName = `${sanitizeFileName(item.name)}_usuario_${item.id}_${dateSuffix}.pdf`;

                    return {
                        pdf: {
                            blob: createSimplePdfBlob(`Cadastro do usuario - ${item.name}`, [
                                `Nome: ${item.name}`,
                                `E-mail: ${item.email || "Nao informado"}`,
                                `CPF: ${item.cpf || "Nao informado"}`,
                                `Telefone: ${item.number || "Nao informado"}`,
                                `Endereco: ${item.address || "Nao informado"}`,
                                `Bairro: ${item.neighborhood || "Nao informado"}`,
                                `Cidade: ${item.city || "Nao informada"}`,
                                `Estado: ${item.state || "Nao informado"}`,
                                `CEP: ${item.postal_code || "Nao informado"}`,
                                `Status: ${item.active ? "Ativo" : "Inativo"}`,
                            ]),
                            fileName: pdfFileName,
                        },
                    };
                },
            });

            downloadBlob(summary.blob, summary.zipFileName);
            toast.update(toastId, {
                render: `Backup de usuários concluído com sucesso. ${summary.pdfCount} PDF(s) incluído(s).`,
                type: "success",
                isLoading: false,
                autoClose: 5000,
            });
        } catch (error) {
            console.error("Erro ao gerar backup de usuários:", error);
            toast.update(toastId, {
                render: "Erro ao gerar o backup dos usuários.",
                type: "error",
                isLoading: false,
                autoClose: 5000,
            });
        } finally {
            setBackupLoading(false);
        }
    };

    const handleSubmitUpdate = async () => {
        console.log("")


         // Chama a função de validação
        if (!validateFormData(formData)) {
            return;
        }
        
            try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post(`/crud/updatedata/UserSubmaster/${String(formData.id)}`, {
                name: formData.name,
                email: formData.email,
                cpf: formData.cpf,
                address: formData.address,
                neighborhood: formData.neighborhood,
                postal_code: formData.postal_code,
                city: formData.city,
                state: formData.state,
                number: formData.number,
                house_number: formData.house_number,
                access_permission_request: formData.active,
            });
        
            // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
            if (response.status >= 200) {
                resetForm();
                toast.success("Atualizado com sucesso! 🎉");
        
                setTimeout(() => {
                window.location.reload();
                }, 1000);
            }else{
                toast.warning("Erro ao editar, por favor verifique os dados como EMAIL OU CPF");
    
            }
            } catch (e) {
                toast.warning("Erro ao editar, por favor verifique os dados como EMAIL OU CPF");
            }

    }
    const resetForm = () => {
        formData.name = '';
        formData.email = '';
        formData.cpf = '';
        formData.address = '';
        formData.neighborhood = '';
        formData.postal_code = '';
        formData.city = '';
        formData.state = '';
        formData.number = '';
        formData.house_number = '';
        formData.submasterId = 0;
        formData.password = ""
        formData.active = true;
    };
      


    const loadingToast  = () => {
        return toast.info("Processando... aguarde", {
          autoClose: false, 
        })
    };

    const isValidAdmissionDate = (admissionDate: string) => {
        const today = new Date();
        const birthDate = new Date(admissionDate);
        const age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        
        // Se a idade for menor que 15, retorna false
        return age > 15 || (age === 15 && month >= 0);
    };

    // Função de validação
   const validateFormData = (formData: any) => {
    const requiredFields = [
        { key: "name", label: "O nome é obrigatório." },
        { key: "cpf", label: "O CPF é obrigatório." },
        { key: "email", label: "O e-mail é obrigatório." },
    ];

    for (const field of requiredFields) {
        const value = formData[field.key];
        if (!value || (typeof value === "string" && !value.trim())) {
        toast.error(field.label);
        return false;
        }
    }

    // Validação extra para o CEP (postal_code) com 8 dígitos
    const cep = formData.postal_code?.replace(/\D/g, '');
   /*if (!cep || cep.length !== 8) {
        toast.error("O CEP deve conter exatamente 8 dígitos.");
        return false;
    }*/

    return true;
    };

    const handleSubmit = async () => {
        console.log("todos os dados... ", formData);
    
        // Chama a função de validação
        if (!validateFormData(formData)) {
        return;
        }
    
        try {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/createUsers/UserSubmaster", {
            name: formData.name,
            email: formData.email,
            cpf: formData.cpf,
            address: formData.address,
            neighborhood: formData.neighborhood,
            postal_code: formData.postal_code,
            city: formData.city,
            state: formData.state,
            number: formData.number,
            house_number: formData.house_number,
            submasterId: Number(localStorage.getId()),
            access_permission_request: true,
            password: formData.password
        });
    
        // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
        if (response.status >= 200) {
            resetForm();
            toast.success("Cadastrado com sucesso! 🎉");
    
            setTimeout(() => {
            window.location.reload();
            }, 1000);
        }else{
            toast.warning("Erro ao registrar, por favor verifique os dados como EMAIL OU CPF");

        }
        } catch (e) {
            toast.warning("Erro ao registrar, por favor verifique os dados como EMAIL OU CPF");
        }
    };


    const handlegetActivisionData = async () => {

        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/getdata/UserSubmaster/" + String(localStorage.getId())  + "/false" );
    
        console.log("dados submaster",response.data)
    
    
        const formatdata = response.data.map((item: any) => ({
            name: item.name,
            email: item.email,
            cpf: item.cpf,
            address: item.address,
            neighborhood: item.neighborhood,
            postal_code: item.postal_code,
            city: item.city,
            state: item.state,
            number: item.number,
            house_number: item.house_number,
            id:item.id,
            active: item.access_permission_request !== false
        }));

        const sortedUsers = sortUsersAlphabetically(formatdata);

        setFormData(formatdata)
        setgetData(sortedUsers)
    }


    useEffect(() => {
        handlegetActivisionData()
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        ApiClient.post("/reportPermissions", {})
            .then((response) => {
                setMasterDataDeleteEnabled(
                    response?.data?.master_data_delete_permission_enabled === true
                );
            })
            .catch(() => setMasterDataDeleteEnabled(false));
    }, []);
    const customStyles = {
  header: {
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#0d6efd',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #dee2e6',
    },
  },
  headCells: {
    style: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#495057',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  rows: {
    style: {
      minHeight: '50px', // altura mínima da linha
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#e9f5ff', // destaque ao passar o mouse
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  pagination: {
    style: {
      borderTop: '1px solid #dee2e6',
      paddingTop: '8px',
      fontSize: '14px',
    },
  },
};


    return (
    <LayoutSubmaster>
       <div className="report-config-page management-page">
            {!showEmployeesFormUpdate ? (
                <div>
                    <section className="dashboard-hero report-hero mb-4">
                        <div className="report-hero__content">
                            <span className="pill-badge">Usuários</span>
                            <h1 className="dashboard-title">Cadastro de usuários</h1>
                            <p className="dashboard-subtitle">
                                Gerencie os usuários vinculados ao painel, mantenha os dados atualizados e encontre registros com mais rapidez.
                            </p>
                        </div>
                        <div className="d-flex flex-wrap gap-2 epi-hero-actions">
                            <div className="report-hero__badge">
                                <i className="bi bi-people" />
                                <div>
                                    <span>Usuários no painel</span>
                                    <strong>{filteredUsers} registros visíveis</strong>
                                </div>
                            </div>
                            {canManageUsers && <button
                              className="btn btn-primary epi-primary-action"
                              onClick={() => {
                                  resetData();
                                  setShowCreatePassword(false);
                                  setShowFormCreateEmployess(true);
                              }}
                            >
                              <i className="bi bi-person-plus-fill me-2"></i> Cadastrar Usuário
                            </button>}
                            <button
                              className="btn btn-outline-primary epi-primary-action"
                              onClick={handleBackup}
                              disabled={backupLoading}
                            >
                              {backupLoading ? (
                                <span className="spinner-border spinner-border-sm me-2" role="status" />
                              ) : (
                                <i className="bi bi-cloud-download me-2"></i>
                              )}
                              Fazer Backup em PDF
                            </button>
                        </div>
                    </section>

                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <article className="dashboard-card metric-card soft report-metric-card">
                          <div className="metric-card__icon">
                            <i className="bi bi-person-lines-fill fs-4 text-primary" />
                          </div>
                          <div>
                            <p className="metric-card__eyebrow">Usuários cadastrados</p>
                            <h2 className="metric-card__value">{totalUsers}</h2>
                            <p className="metric-card__caption">Registros disponíveis para consulta</p>
                          </div>
                        </article>
                      </div>
                      <div className="col-md-6">
                        <article className="dashboard-card metric-card soft report-metric-card">
                          <div className="metric-card__icon">
                            <i className="bi bi-funnel fs-4 text-primary" />
                          </div>
                          <div>
                            <p className="metric-card__eyebrow">Resultado atual</p>
                            <h2 className="metric-card__value">{filteredUsers}</h2>
                            <p className="metric-card__caption">Linhas filtradas na busca atual</p>
                          </div>
                        </article>
                      </div>
                    </div>

                    <section className="section-panel report-table-panel">
                      <div className="section-heading">
                        <div>
                          <h3>Tabela de usuários</h3>
                          <p>Consulte os usuários e acesse a edição sem sair da listagem.</p>
                        </div>
                        <div className="input-group management-search">
                          <span className="input-group-text bg-white border-end-0">
                            <i className="bi bi-search text-secondary"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control border-start-0"
                            placeholder="Filtrar por usuário"
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                          />
                        </div>
                      </div>

                      <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        highlightOnHover
                        pointerOnHover
                        responsive
                        customStyles={customStyles}
                        paginationComponentOptions={{
                          rowsPerPageText: "Linhas por página",
                          rangeSeparatorText: "de",
                          selectAllRowsItem: true,
                          selectAllRowsItemText: "Selecionar todos",
                        }}
                        noHeader
                      />
                    </section>
                </div>
            ) :
                <div className="col-md-12 ">
                     <div className="modal-content shadow-lg epi-modal" style={{ borderRadius: "1rem", overflow: "hidden" }}>
                        {/* Cabeçalho */}
                        <div
                            className="modal-header "
                            style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}
                        >
                            <h5 className="modal-title" style={{ color: "white" }}>
                                <i className="bi bi-person-plus-fill me-2"></i> Editar Usuário
                            </h5>
                        </div>
                        {/* Corpo do Modal */}
                        <div className="modal-body epi-modal__body">
                            <form>
                                <div className="container">

                                {/* Linha 1: Nome e Email */}
                                <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="name" className="form-label">Nome</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-person-fill text-primary"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-control"
                                        placeholder="Nome"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        />
                                    </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="email" className="form-label">E-mail</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-envelope-fill text-warning"></i>
                                        </span>
                                        <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="E-mail"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        />
                                    </div>
                                    </div>
                                </div>

                                {/* Linha 2: CPF e Telefone */}
                                <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="cpf" className="form-label">CPF</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-credit-card-2-front-fill text-secondary"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="cpf"
                                        name="cpf"
                                        className="form-control"
                                        placeholder="CPF"
                                        value={formData.cpf}
                                        onChange={handleChange}
                                        required
                                        />
                                    </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="number" className="form-label">Telefone</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-telephone-fill text-success"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="number"
                                        name="number"
                                        className="form-control"
                                        placeholder="Número de telefone"
                                        value={formData.number}
                                        onChange={maskPhone}
                                        required
                                        />
                                    </div>
                                    </div>
                                </div>

                                {/* Linha 3: Endereço e Número da Casa */}
                                <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="address" className="form-label">Endereço</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-geo-alt-fill text-info"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        className="form-control"
                                        placeholder="Endereço"
                                        value={formData.address}
                                        onChange={handleChange}
                                        
                                        
                                        />
                                    </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="house_number" className="form-label">Número da Casa</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-house-door-fill text-secondary"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="house_number"
                                        name="house_number"
                                        className="form-control"
                                        placeholder="Número"
                                        value={formData.house_number}
                                        onChange={handleChange}
                                        required
                                        />
                                    </div>
                                    </div>
                                </div>

                                {/* Linha 4: Bairro e CEP */}
                                <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="neighborhood" className="form-label">Bairro</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-building text-primary"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="neighborhood"
                                        name="neighborhood"
                                        className="form-control"
                                        placeholder="Bairro"
                                        value={formData.neighborhood}
                                        onChange={handleChange}
                                     
                                        />
                                    </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="postal_code" className="form-label">CEP</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-mailbox2 text-warning"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="postal_code"
                                        name="postal_code"
                                        className="form-control"
                                        placeholder="CEP"
                                        value={formData.postal_code}
                                        onChange={handleChangePostalcode}
                                        maxLength={8}
                                        minLength={8}
                                        />
                                    </div>
                                    </div>
                                </div>

                                {/* Linha 5: Cidade e Estado */}
                                <div className="row mb-3">
                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="city" className="form-label">Cidade</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-building-fill text-info"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        className="form-control"
                                        placeholder="Cidade"
                                        value={formData.city}
                                        onChange={handleChange}
                                        />
                                    </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                    <label htmlFor="state" className="form-label">Estado</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                        <i className="bi bi-flag-fill text-danger"></i>
                                        </span>
                                        <input
                                        type="text"
                                        id="state"
                                        name="state"
                                        className="form-control"
                                        placeholder="Estado"
                                        value={formData.state}
                                        onChange={handleChange}
                                        />
                                    </div>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div
                                            className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 p-3"
                                            style={{
                                                border: "1px solid rgba(13, 110, 253, 0.18)",
                                                borderRadius: "14px",
                                                background: formData.active
                                                    ? "rgba(25, 135, 84, 0.07)"
                                                    : "rgba(108, 117, 125, 0.09)",
                                            }}
                                        >
                                            <div>
                                                <div className="fw-bold mb-1">Acesso ao aplicativo</div>
                                                <div className="text-secondary small">
                                                    Usuários inativos não conseguem entrar no app.
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-3">
                                                <span className={`badge ${formData.active ? "bg-success" : "bg-secondary"}`}>
                                                    {formData.active ? "Ativo" : "Inativo"}
                                                </span>
                                                <div className="form-check form-switch m-0">
                                                    <input
                                                        id="user-active-status"
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        checked={formData.active}
                                                        onChange={(event) =>
                                                            setFormData((current) => ({
                                                                ...current,
                                                                active: event.target.checked,
                                                            }))
                                                        }
                                                        style={{ width: "2.8rem", height: "1.4rem" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                            </form>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer">
                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowEmployeesFormUpdate(false)}
                        >
                            Fechar
                        </button>
                        <button
                            className="btn btn-outline-primary"
                            onClick={handleSubmitUpdate}
                        >
                            <i className="bi bi-check-circle me-2"></i> Salvar Alteração
                        </button>
                        </div>
                    </div>
                </div>
            }
        </div>

       {showFormCreateUser && (
            <div className="modal fade show d-block">
                <div className="modal-dialog modal-xl">
                <div className="modal-content shadow-lg epi-modal" style={{ borderRadius: "1rem", overflow: "hidden" }}>
                    {/* Cabeçalho */}
                    <div
                    className="modal-header "
                    style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}
                    >
                        <h5 className="modal-title" style={{ color: "white" }}>
                            <i className="bi bi-person-plus-fill me-2"></i> Cadastro de Usuário
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white mt-3 mr-3"
                            onClick={() => {
                                setShowCreatePassword(false);
                                setShowFormCreateEmployess(false);
                            }}
                        ></button>
                    </div>

                    {/* Corpo do Modal */}
                    <div className="modal-body epi-modal__body">
                    <form>
                        <div className="container">

                        {/* Linha 1: Nome e Email */}
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="name" className="form-label">Nome</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-person-fill text-primary"></i>
                                </span>
                                <input
                                type="text"
                                id="name"
                                name="name"
                                className="form-control"
                                placeholder="Nome"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="email" className="form-label">E-mail</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-envelope-fill text-warning"></i>
                                </span>
                                <input
                                type="email"
                                id="email"
                                name="email"
                                className="form-control"
                                placeholder="E-mail"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 2: CPF e Telefone */}
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="cpf" className="form-label">CPF</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-credit-card-2-front-fill text-secondary"></i>
                                </span>
                                <input
                                type="text"
                                id="cpf"
                                name="cpf"
                                className="form-control"
                                placeholder="CPF"
                                value={formData.cpf}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="number" className="form-label">Telefone</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-telephone-fill text-success"></i>
                                </span>
                                <input
                                type="text"
                                id="number"
                                name="number"
                                className="form-control"
                                placeholder="Número de telefone"
                                value={formData.number}
                                onChange={maskPhone}
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 3: CEP e Endereço */}
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="postal_code" className="form-label">CEP</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-mailbox2 text-warning"></i>
                                </span>
                                <input
                                type="text"
                                id="postal_code"
                                name="postal_code"
                                className="form-control"
                                placeholder="CEP"
                                value={formData.postal_code}
                                onChange={handleChangePostalcode}
                                maxLength={8}
                                minLength={8}
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="address" className="form-label">Endereço</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-geo-alt-fill text-info"></i>
                                </span>
                                <input
                                type="text"
                                id="address"
                                name="address"
                                className="form-control"
                                placeholder="Endereço"
                                value={formData.address}
                                onChange={handleChange}
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 4: Número e Bairro */}
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="house_number" className="form-label">Número</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-house-door-fill text-secondary"></i>
                                </span>
                                <input
                                type="text"
                                id="house_number"
                                name="house_number"
                                className="form-control"
                                placeholder="Número"
                                value={formData.house_number}
                                onChange={handleChange}
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="neighborhood" className="form-label">Bairro</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-building text-primary"></i>
                                </span>
                                <input
                                type="text"
                                id="neighborhood"
                                name="neighborhood"
                                className="form-control"
                                placeholder="Bairro"
                                value={formData.neighborhood}
                                onChange={handleChange}
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 5: Cidade e Estado */}
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="city" className="form-label">Cidade</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-building-fill text-info"></i>
                                </span>
                                <input
                                type="text"
                                id="city"
                                name="city"
                                className="form-control"
                                placeholder="Cidade"
                                value={formData.city}
                                onChange={handleChange}
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="state" className="form-label">Estado</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-flag-fill text-danger"></i>
                                </span>
                                <input
                                type="text"
                                id="state"
                                name="state"
                                className="form-control"
                                placeholder="Estado"
                                value={formData.state}
                                onChange={handleChange}
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 6: Senha */}
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="password" className="form-label">Senha</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-lock-fill text-secondary"></i>
                                </span>
                                <input
                                type={showCreatePassword ? "text" : "password"}
                                id="password"
                                name="password"
                                className="form-control"
                                placeholder="Senha"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                />
                                <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowCreatePassword((visible) => !visible)}
                                aria-label={showCreatePassword ? "Ocultar senha" : "Visualizar senha"}
                                title={showCreatePassword ? "Ocultar senha" : "Visualizar senha"}
                                aria-pressed={showCreatePassword}
                                >
                                <i className={`bi ${showCreatePassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                                </button>
                            </div>
                            </div>
                        </div>

                        </div>
                    </form>
                    </div>

                    {/* Footer */}
                    <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => {
                            setShowCreatePassword(false);
                            setShowFormCreateEmployess(false);
                        }}
                    >
                        Fechar
                    </button>
                    <button
                        className="btn btn-outline-primary"
                        onClick={handleSubmit}
                    >
                        <i className="bi bi-check-circle me-2"></i> Salvar
                    </button>
                    </div>
                </div>
                </div>
            </div>
        )}


        
        {/* Background escuro (overlay) */}
        {(showFormCreateUser) && <div className="modal-backdrop fade show"></div>}
            
    </LayoutSubmaster>)
}


export default ConfigSubmasterUserPage
